import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=516b2cf2&scoped=true&"
import script from "./AffiliateList.vue?vue&type=script&lang=js&"
export * from "./AffiliateList.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateList.vue?vue&type=style&index=0&id=516b2cf2&lang=scss&scoped=true&"
import style1 from "./AffiliateList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AffiliateList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b2cf2",
  null
  
)

export default component.exports